export const DAYS = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"];
export const WEEK = ["mon", "tue", "wed", "thu", "fri", "sat", "sun"];
export const DAY_LABELS = { mon: "Monday", tue: "Tuesday", wed: "Wednesday", thu: "Thursday", fri: "Friday", sat: "Saturday", sun: "Sunday" };

export const todayKey = (d = new Date()) => DAYS[d.getDay()];
const toMin = (t) => {
  const [h, m] = t.split(":").map(Number);
  return h * 60 + m;
};

export function fmtTime(t) {
  const [h, m] = t.split(":").map(Number);
  const ap = h >= 12 ? "pm" : "am";
  const hh = h % 12 || 12;
  return m ? `${hh}:${String(m).padStart(2, "0")}${ap}` : `${hh}${ap}`;
}

export const fmtWindow = (w) => (w ? `${fmtTime(w.start)} – ${fmtTime(w.end)}` : "No happy hour");

const TZ = {
  AK: "America/Anchorage", HI: "Pacific/Honolulu", AZ: "America/Phoenix",
  WA: "America/Los_Angeles", OR: "America/Los_Angeles", CA: "America/Los_Angeles", NV: "America/Los_Angeles",
  MT: "America/Denver", ID: "America/Denver", WY: "America/Denver", UT: "America/Denver", CO: "America/Denver", NM: "America/Denver",
  ND: "America/Chicago", SD: "America/Chicago", NE: "America/Chicago", KS: "America/Chicago", OK: "America/Chicago", TX: "America/Chicago",
  MN: "America/Chicago", IA: "America/Chicago", MO: "America/Chicago", AR: "America/Chicago", LA: "America/Chicago", WI: "America/Chicago",
  IL: "America/Chicago", MS: "America/Chicago", AL: "America/Chicago", TN: "America/Chicago",
};
const SHORT = { Sun: "sun", Mon: "mon", Tue: "tue", Wed: "wed", Thu: "thu", Fri: "fri", Sat: "sat" };

export function venueClock(venue, now = new Date()) {
  const tz = TZ[venue.state] || "America/New_York";
  const p = Object.fromEntries(
    new Intl.DateTimeFormat("en-US", { timeZone: tz, weekday: "short", hour: "2-digit", minute: "2-digit", second: "2-digit", hourCycle: "h23" })
      .formatToParts(now).map((x) => [x.type, x.value])
  );
  return { day: SHORT[p.weekday], minutes: Number(p.hour) * 60 + Number(p.minute) + Number(p.second) / 60 };
}

export function hhStatus(venue, now = new Date()) {
  const clock = venueClock(venue, now);
  const w = venue.hours?.[clock.day];
  if (!w) return { state: "closed", label: "No happy hour today" };
  const cur = clock.minutes;
  const s = toMin(w.start);
  let e = toMin(w.end);
  if (e <= s) e += 1440;
  if (cur >= s && cur < e) {
    const left = Math.round((e - cur) * 60);
    return { state: left < 3600 ? "ending" : "open", seconds: left };
  }
  if (cur < s) return { state: "closed", startsIn: Math.round((s - cur) * 60) };
  return { state: "closed", label: "Ended for today" };
}

export function fmtDur(sec) {
  const h = Math.floor(sec / 3600);
  const m = Math.floor((sec % 3600) / 60);
  const s = sec % 60;
  if (h) return `${h}h ${m}m`;
  return `${m}m ${String(s).padStart(2, "0")}s`;
}

export const money = (n) => `$${Number(n).toFixed(2).replace(/\.00$/, "")}`;

export function cheapestDrink(v) {
  const p = (v.specials || []).filter((s) => s.category === "drink").map((s) => s.price);
  return p.length ? Math.min(...p) : Infinity;
}

export const isFeatured = (v) => !!v.featured_until && new Date(v.featured_until) > new Date();
export const isLive = (v, now = new Date()) => hhStatus(v, now).state !== "closed";

export const directionsUrl = (v, apple = false) =>
  apple
    ? `https://maps.apple.com/?daddr=${v.lat},${v.lng}&dirflg=w`
    : `https://www.google.com/maps/dir/?api=1&destination=${v.lat},${v.lng}`;

export function haversine(a, b) {
  const R = 3958.8;
  const rad = (x) => (x * Math.PI) / 180;
  const dLat = rad(b.lat - a.lat);
  const dLng = rad(b.lng - a.lng);
  const h = Math.sin(dLat / 2) ** 2 + Math.cos(rad(a.lat)) * Math.cos(rad(b.lat)) * Math.sin(dLng / 2) ** 2;
  return 2 * R * Math.asin(Math.sqrt(h));
}

export function applyFilters(venues, f, now = new Date()) {
  const isToday = f.day === todayKey(now);
  let list = venues.filter((v) => v.hours?.[f.day]);
  if (isToday && f.openNow) list = list.filter((v) => isLive(v, now));
  if (isToday && f.endingSoon) list = list.filter((v) => hhStatus(v, now).state === "ending");
  if (f.under5) list = list.filter((v) => cheapestDrink(v) < 5);
  const key = f.sort === "cheapest" ? cheapestDrink : (v) => v.distance ?? 0;
  return [...list].sort((a, b) => (isFeatured(b) - isFeatured(a)) || key(a) - key(b));
}
